"use strict";

angular.module("core")
.directive("userVerification", function(
    UserVerificationService, ModalService
) {
    return {
        restrict: "A",
        scope: {
            verificationType: '<userVerification', // Choices: keys in ONBOARDING_USER_VERIFICATION_TYPES and PAYMENT_USER_VERIFICATION_TYPES
            verificationCallback: '&', // Usage with arguments: verification-callback="callback(foo)"
            verificationCallbackArguments: '<?', // Usage: verification-callback-arguments="{foo: 'bar'}"
            verificationRequired: '<?',
            isVerified: '<?',
            verificationMessage: '<?'
        },
        bindToController: true,
        link: function(scope, iElement, iAttrs, controller) {
            iElement.off("click");
            iElement.attr("wg-click", "checkUserVerification()");
            iElement.on("click", controller.checkUserVerification);
        },
        controllerAs: "userVerificationCtrl",
        controller: function($scope) {
            var _this = this;
            this.userData = {};
            $scope.disabled = false;

            this.$onInit = function() {
                if (this.verificationCallbackArguments === undefined) {
                    this.verificationCallbackArguments = {};
                }

                if (this.verificationRequired === undefined) {
                    this.verificationRequired = true;
                }
            }

            this.checkUserVerification = function() {
                if (!_this.verificationRequired) {
                    _this.callback();
                    return;
                }

                if ($scope.disabled) {
                    return;
                }

                $scope.disabled = true;

                UserVerificationService.getUserData(_this.verificationType)
                .then(function(response) {
                    var data = response.data;
                    var isVerified = data.is_verified;
                    if (isVerified) {
                        _this.callback();
                    }
                    else {
                        _this.userData = data;
                        _this.openUserVerificationModal();
                    }
                });
            };

            this.callback = function() {
                _this.verificationCallback(_this.verificationCallbackArguments);
                $scope.disabled = false;
            };

            this.openUserVerificationModal = function() {
                if (!_this.verificationRequired) {
                    _this.callback();
                    return;
                }

                ModalService.showModal({
                    templateUrl: require("./modals/user-verification.modal.html"),
                    controller: "UserVerificationModalController",
                    controllerAs: "userVerificationModalCtrl",
                    inputs: {
                        $attrs: {
                            verificationMessage: _this.verificationMessage,
                            verificationType: _this.verificationType,
                            userData: _this.userData,
                        }
                    }
                }).then(function(modal) {
                    modal.element.modal({
                        backdrop: "static",
                        keyboard: false
                    });
                    modal.element.on("hidden.bs.modal", function(e) {
                        modal.element.remove();
                        $scope.disabled = false;
                    });
                    modal.close.then(function(result) {
                        modal.element.remove();
                        if (result) {
                            _this.callback();
                        }
                    });
                });
            };
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/user-verification/user-verification.directive.js
// module id = 501
// module chunks = 0